export const changeRepos = (userGithubId: number) => {
  const settingsUrl =
    `https://github.com/apps/${process.env.GITHUB_APP_SLUG}/installations/new/permissions?target_id=${userGithubId}`
  window.open(settingsUrl, '_blank')
}
